(() => {
  const closeMenus = (event) => {
    document.querySelectorAll('.trh-header details[open]').forEach((menu) => {
      if (event.type === 'keydown' && event.key === 'Escape') {
        menu.open = false;
        menu.querySelector('summary')?.focus();
      } else if (event.type === 'click' && !menu.contains(event.target)) {
        menu.open = false;
      }
    });
  };
  document.addEventListener('click', closeMenus);
  document.addEventListener('keydown', closeMenus);
  document.querySelectorAll('.trh-mobile-nav a').forEach((link) => link.addEventListener('click', () => {
    const menu = link.closest('details');
    if (menu) menu.open = false;
  }));
  document.querySelectorAll('.trh-cookie-settings').forEach((button) => {
    if (typeof window.Shopify?.customerPrivacy?.showPreferences === 'function') {
      button.addEventListener('click', () => window.Shopify.customerPrivacy.showPreferences());
    } else {
      button.hidden = true;
    }
  });
})();

